class CountdownTimer extends HTMLElement {
    connectedCallback() {
        this.countdownBar = this.querySelector('#countdown-timer-bar');
        this.countdownElement = this.querySelector('#sale-countdown');

        if (!this.countdownBar || !this.countdownElement) return;

        this.saleStartDate = new Date(this.dataset.startDate);
        this.saleEndDate = new Date(this.dataset.endDate);

        this.daysEl = this.querySelector('#sale-countdown-d');
        this.hoursEl = this.querySelector('#sale-countdown-h');
        this.minutesEl = this.querySelector('#sale-countdown-m');
        this.secondsEl = this.querySelector('#sale-countdown-s');

        this.updateCountdown();
        this.timer = setInterval(() => this.updateCountdown(), 1000);

        this.lastViewportWidth = window.innerWidth;
        this.handleResize = () => {
            if (window.innerWidth !== this.lastViewportWidth) {
                this.lastViewportWidth = window.innerWidth;
                this.updateHeaderHeight();
            }
        };

        window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
        clearInterval(this.timer);
        window.removeEventListener('resize', this.handleResize);
    }

    updateHeaderHeight() {
        document.body.style.setProperty(
            '--header-countdown-timer-height',
            this.countdownBar.classList.contains('hidden')
                ? '0px'
                : `${this.countdownBar.offsetHeight}px`
        );
    }

    updateCountdown() {
        const timeLeft = this.saleEndDate - Date.now();

        if (timeLeft <= 0) {
            this.countdownBar.classList.add('hidden');
            this.countdownBar.classList.remove('flex');

            this.updateHeaderHeight();

            clearInterval(this.timer);
            return;
        }

        const days = String(Math.floor(timeLeft / 86400000)).padStart(2, '0');
        const hours = String(Math.floor((timeLeft % 86400000) / 3600000)).padStart(2, '0');
        const minutes = String(Math.floor((timeLeft % 3600000) / 60000)).padStart(2, '0');
        const seconds = String(Math.floor((timeLeft % 60000) / 1000)).padStart(2, '0');

        this.daysEl.textContent = days;
        this.hoursEl.textContent = hours;
        this.minutesEl.textContent = minutes;
        this.secondsEl.textContent = seconds;

        if (!this.countdownBar.classList.contains('flex')) {
            this.countdownBar.classList.remove('hidden');
            this.countdownBar.classList.add('flex');

            this.updateHeaderHeight();
        }
    }

    updateCountdown() {
        const now = Date.now();

        if (
            this.dataset.startDate &&
            !isNaN(this.saleStartDate.getTime()) &&
            now < this.saleStartDate.getTime()
        ) {
            return;
        }

        const timeLeft = this.saleEndDate - now;

        if (timeLeft <= 0) {
            this.countdownBar.classList.add('hidden');
            this.countdownBar.classList.remove('flex');

            this.updateHeaderHeight();

            clearInterval(this.timer);
            return;
        }

        const days = String(Math.floor(timeLeft / 86400000)).padStart(2, '0');
        const hours = String(Math.floor((timeLeft % 86400000) / 3600000)).padStart(2, '0');
        const minutes = String(Math.floor((timeLeft % 3600000) / 60000)).padStart(2, '0');
        const seconds = String(Math.floor((timeLeft % 60000) / 1000)).padStart(2, '0');

        this.daysEl.textContent = days;
        this.hoursEl.textContent = hours;
        this.minutesEl.textContent = minutes;
        this.secondsEl.textContent = seconds;

        if (!this.countdownBar.classList.contains('flex')) {
            this.countdownBar.classList.remove('hidden');
            this.countdownBar.classList.add('flex');

            this.updateHeaderHeight();
        }
    }
}

if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
}